import React, { useState, useEffect } from 'react';
import { map, get, size } from 'lodash';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { object } from 'prop-types';
import { FlexContainer, Loading, Drawer, Divider, Text, Icon } from '../../common';
import { Row, Col } from 'antd';
import MediaListener from '../../utils/MediaListener';
import { Main } from 'base-components';
import Card from './Card';
import { GET_MAIL_REPORT } from '../../../queries';
import { Query } from '../../graphql';
import ModalDelete from './ModalDelete';

const AddresseesNotifications = ({ session, client }) => {
    const [visibleModalDelete, setVisibleModalDelete] = useState(false);
    const [infoToModalDelete, setInfoToModalDelete] = useState({});
    const toggleModalDelete = () => setVisibleModalDelete(!visibleModalDelete);
    const [drawerEmails, setDrawerEmails] = useState([]);
    const [drawerItemKey, setDrawerItemKey] = useState('');
    const [drawerVisible, setDrawerVisible] = useState(false);


    const truncateText = (text, sizeToTruncate) => size(text) > sizeToTruncate ? `${text.substring(0, sizeToTruncate - 1)}...` : text;

    return (
        <Main background='#f4f4f4' withFooter>
            <MediaListener values={['16.7%', '100%', '100%']}>
                {({ currentValue }) => {
                    return (
                        <>
                            <FlexContainer direction='row' background='#f4f4f4' style={{ flexWrap: 'wrap', backgroundColor: '#f4f4f4' }} height='100%'>
                                <Query
                                        query={GET_MAIL_REPORT}
                                    >
                                        {({ data, loading, networkStatus }) => {
                                            const mailReports = get(data, 'getMailReport', []);
                                            return <Loading loading={networkStatus === 4 ? false : loading}>
                                                <Row style={{ width: '100%' }}>
                                                    {map(mailReports, ({ nameReport, emails, jobName }) => {
                                                        return (
                                                            <Card
                                                                setDrawerEmails={(emails) => setDrawerEmails(emails)}
                                                                setDrawerItemKey={(itemKey) => setDrawerItemKey(itemKey)}
                                                                setVisibleModaDetail={setDrawerVisible}
                                                                client={client}
                                                                name={nameReport}
                                                                itemKey={jobName}
                                                                addressees={emails}
                                                                setInfoToModalDelete={setInfoToModalDelete}
                                                                setVisibleModalDelete={setVisibleModalDelete}
                                                            />
                                                        );
                                                    })}
                                                </Row>
                                                <Drawer
                                                    values={['25%', '25%', '100%']}
                                                    closable
                                                    title={'Detalle'}
                                                    visible={drawerVisible}
                                                    onClose={() => setDrawerVisible(!drawerVisible)}
                                                >
                                                    <Row gutter={16} style={{ width: '100%' }}>
                                                        {map(drawerEmails, (email, index) => {
                                                            return <Row key={email + index}>
                                                                <Divider style={{ margin: '5px 0px' }} />
                                                                <Row gutter={16}>
                                                                    <Col span={20}>
                                                                        <Text text={truncateText(email, 37)} truncate size={12} />
                                                                    </Col>
                                                                    <Col span={4} style={{ textAlign: 'center' }}>
                                                                        <Icon name='trash' color='#A4C735' size={12} pointer onClick={async () => {
                                                                            setInfoToModalDelete({ email, itemKey: drawerItemKey });
                                                                            setVisibleModalDelete(true);
                                                                        }} />
                                                                    </Col>
                                                                </Row>
                                                            </Row>;
                                                        })}
                                                    </Row>
                                                </Drawer>
                                            </Loading>;
                                        }}
                                    </Query>
                                
                            </FlexContainer>
                            <ModalDelete
                                setDrawerVisible={setDrawerVisible}
                                infoToModalDelete={infoToModalDelete}
                                visible={visibleModalDelete}
                                toggleModal={toggleModalDelete}
                            />
                        </>
                    );
                }}
            </MediaListener>
        </Main>
    );
};

AddresseesNotifications.propTypes = {
    session: object,
    client: object
};

export default withRouter(withApollo(AddresseesNotifications));
